import { Skeleton, Stack } from '@mui/material';
import type { FC } from 'react';

const ProfilePageSkeleton: FC = () => (
  <Stack spacing={2}>
    <Skeleton variant='text' sx={{ maxWidth: '470px' }} />
    <Skeleton variant='text' sx={{ maxWidth: '450px' }} />
    <Skeleton variant='text' sx={{ maxWidth: '500px' }} />
    <Skeleton variant='rectangular' sx={{ maxWidth: '550px' }} height={60} />
  </Stack>
);

export default ProfilePageSkeleton;
